import script from "./CustomPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomPopup.vue?vue&type=script&setup=true&lang=js"

import "./CustomPopup.vue?vue&type=style&index=0&id=7b291491&lang=scss"

const __exports__ = script;

export default __exports__